import axios from 'axios';

export function getAdvertiserSignupCategories() {
    return axios.get(`${process.env.REACT_APP_API_URL}/advertiser/signup/categories`);
}
